import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fort-awesome': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M489.2 287.9H461.8C459.2 287.9 457.2 289.9 457.2 292.5V324.5H420.6V146.2C420.6 143.6 418.6 141.6 416 141.6H388.6C386 141.6 384 143.6 384 146.2V178.2H347.4V146.2C347.4 143.6 345.4 141.6 342.8 141.6H315.4C312.8 141.6 310.8 143.6 310.8 146.2V178.2H274.2V146.2C274.2 140.2 266.2 141.6 262.5 141.6V103.6C270.8 101.6 279.6 100.2 288.2 100.2 299.1 100.2 309.1 104.5 319.6 104.5 324.2 104.5 347.3 103.4 347.3 96.5V36.5C347.3 33.9 345.3 31.9 342.7 31.9 337.6 31.9 327.6 36.2 318.7 36.2 309 36.2 297.8 31.9 286.1 31.9 278.1 31.9 270.1 33 262.4 34.8V29.9C267.8 27.3 271.5 21.6 271.5 15.6 271.5-5.1 240.1-5.2 240.1 15.6 240.1 21.6 243.8 27.3 249.2 29.9V141.6C245.5 141.6 237.5 140.2 237.5 146.2V178.2H200.9V146.2C200.9 143.6 198.9 141.6 196.3 141.6H168.9C166.3 141.6 164.3 143.6 164.3 146.2V178.2H128V146.2C128 143.6 126 141.6 123.4 141.6H96C93.4 141.6 91.4 143.6 91.4 146.2V324.5H54.8V292.5C54.8 289.9 52.8 287.9 50.2 287.9H22.8C20.2 287.9 18.2 289.9 18.2 292.5V512H201.1V416C201.1 343.4 310.8 343.4 310.8 416V512H493.7V292.5C493.8 289.9 491.8 287.9 489.2 287.9zM201.1 283.4C201.1 286 199.1 288 196.5 288H169.1C166.5 288 164.5 286 164.5 283.4V219.4C164.5 216.8 166.5 214.8 169.1 214.8H196.5C199.1 214.8 201.1 216.8 201.1 219.4V283.4zM347.5 283.4C347.5 286 345.5 288 342.9 288H315.5C312.9 288 310.9 286 310.9 283.4V219.4C310.9 216.8 312.9 214.8 315.5 214.8H342.9C345.5 214.8 347.5 216.8 347.5 219.4V283.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fort-awesome.js
// module id = V4YR
// module chunks = 144